import {
  FetchOrganizationListParams,
  Organization,
} from "@/types/organization";
import { handleRequest } from "..";
import { httpAuthorized } from "@/util/http";

export const fetchOrganizationListApi = (
  query: FetchOrganizationListParams
): Promise<Organization[] | null> => {
  return handleRequest<Organization[]>(
    httpAuthorized.get("/organization/getList", { params: query }),
    (data) => data.data.result
  );
};

export const createOrganizationApi = (
  organization: Organization
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/organization/create", organization),
    (data) => data.data.result
  );
};

export const fetchOrganizationInfoApi = (
  orgId: string
): Promise<Organization | null> => {
  return handleRequest<Organization>(
    httpAuthorized.get("/organization/getById", { params: { orgId } }),
    (data) => data.data.result
  );
};
